<template>
  <div class="locale-view">
    <div class="toolbar">
      <div class="filter-item" v-for="(field, name) in searchFields" :key="name">
        <el-select v-if="field.filters" v-model="searchFilter[name]" :placeholder="field.label" clearable>
          <el-option v-for="(lvn, lv) in field.filters" :key="lv" :label="lvn" :value="lv"></el-option>
        </el-select>
        <el-input v-else v-model="searchFilter[name]" :placeholder="field.label" clearable/>
      </div>
      <el-input v-model="search" placeholder="输入关键字搜索" clearable/>
      <el-button @click="fetchData" icon="el-icon-refresh"></el-button>
      <el-button @click="downloadData" icon="el-icon-download"></el-button>
    </div>
    <el-table :data="items" border style="width: 100%">
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column width="50">
        <template #header="column">
          <el-popover placement="bottom" width="130" popper-class="langs-filters">
            <el-checkbox-group v-model="langList">
              <el-checkbox v-for="(title, lang) in langs" :key="lang" :label="lang" style="display:block;">{{title}}</el-checkbox>
            </el-checkbox-group>
            <div style="text-align: center; margin: 8px 0 0 0;">
              <el-button size="mini" type="text" @click="langList = []">清除</el-button>
            </div>
            <span class="langs-column" slot="reference"># <i class="el-icon-more"></i></span>
          </el-popover>
        </template>
        <template #default="column">
          {{column.$index + index}}
        </template>
      </el-table-column>
      <el-table-column :prop="'columns.' + key" :label="column.label" v-for="(column, key) in customColumns" :key="key"></el-table-column>
      <el-table-column v-for="(lang, key) in columns" :key="key" :label="langs[lang]">
        <template v-slot="column">
          <a href="#" @click.prevent.stop="handleShowPop($event, column, lang)"
            :class="{trans: true, empty: !column.row.translations[lang]}"
            slot="reference" v-html="getRowText(lang, column.row)"
            ></a>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      v-if="total>pageSize"
    >
    </el-pagination>
    <el-popover ref="pop" placement="bottom" width="300" :reference="editElement">
      <el-input type="textarea" v-model="editText" :autosize="{minRows:2}" resize="none" @change="handleEditChange"></el-input>
      <div style="text-align: right; margin: 12px 0 0 0;">
        <el-button size="mini" type="text" @click="$refs.pop.doClose()">取消</el-button>
        <el-button type="primary" size="mini" @click="handleSubmit">确定</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script>
import utils from './../../js/utils.js'
import qs from 'qs'

export default {
  name: 'Locale',
  props: {
    searchUrl: String,
    updateUrl: String,
    group: String,
    langs: {
      type: Object,
      default () {
        return {
          'zh': '中文',
          'en': '英文(English)',
          'ja': '日文(日本語)',
          'ko': '韩文(한국어)',
          'vi': '越南(Tiếng Việt)',
          'th': '泰语(ภาษาไทย)',
          'ru': '俄语(Русский)',
          'es': '西班牙语(español)',
          'fr': '法语(Français)',
          'ar': '阿拉伯语(اللغة العربية)',
          'ug': '维吾尔语(ئۇيغۇر تىلى)',
          'de': "德语(German)",
          'pt': "葡萄牙语(Português)",
          'it': "意大利语(Italian)",
          'id': "印尼语(Bahasa Indonesia)",
        }
      }
    },
    showLangs: Array
  },
  data () {
    return {
      index: 1,
      search: '',
      items: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      pageCount: 0,
      editText: '',
      editElement: null,
      editItem: null,
      editLang: null,
      langList: [],
      customColumns: [],
      searchFields: null,
      searchFilter: {},
      loading: false
    }
  },
  computed: {
    columns () {
      if (this.showLangs && this.showLangs.length > 0) {
        return this.showLangs
      }
      if (this.langList && this.langList.length > 0) {
        return this.langList
      }
      return Object.keys(this.langs)
    },
    filters () {
      return Object.keys(this.langs).map((k) => {
        return { text: this.langs[k], value: k }
      })
    }
  },
  watch: {
    group: {
      handler () {
        this.searchFields = null
        this.fetchData()
      },
      immediate: true
    },
    search () {
      this.fetchData()
    },
    searchFilter: {
      handler () {
        if (!this.loading) {
          this.fetchData()
        }
      },
      deep: true
    }
  },
  created () {
    this.fetchData = utils.throttle(this.fetchData, 800)
  },
  methods: {
    fetchData () {
      if (!this.group) {
        return;
      }
      this.loading = true
      this.$http.get(this.searchUrl || this.$urls.locale_search, {
        params: Object.assign({
          id: this.group,
          wd: this.search,
          langs: this.langList,
          page: this.currentPage,
          'per-page': this.pageSize,
        }, this.searchFilter)
      }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.pageCount = Number.parseInt(res.headers['x-pagination-page-count'])
        this.index = (this.currentPage - 1) * this.pageSize + 1
        this.items = res.data.items
        this.customColumns = res.data.columns
        if (this.searchFields === null) {
          this.searchFields = res.data.searchFields || []
          this.searchFilter = {}
        }
        window.setTimeout(() => {
          this.loading = false
        }, 10)
      })
    },
    downloadData() {
      let authKey = localStorage.getItem('authKey') || sessionStorage.getItem('authKey')
      let params = Object.assign({
        id: this.group,
        wd: this.search,
        langs: this.langList,
        auth_key: authKey,
      }, this.searchFilter)
      let url = this.$http.defaults.baseURL + '/api/locale/download?' + qs.stringify(params)
      window.open(url)
    },
    getRowText (lang, row) {
      if (lang === row.keyLanguage) {
        return row.key
      }
      if (!row.translations[lang] || /^\s*$/.test(row.translations[lang])) {
        return '(未设置)'
      }
      return row.translations[lang].replace(/\n/gm, '<br/>')
    },
    showPop (event, col, lang) {
      this.editLang = lang
      this.editItem = col.row
      if (col.row.modifies && col.row.modifies[lang]) {
        this.editText = col.row.modifies[lang]
      } else if (lang === col.row.keyLanguage) {
        this.editText = col.row.key
      } else {
        this.editText = col.row.translations[lang]
      }
      this.editElement = event.target
      this.$refs.pop.referenceElm = this.editElement
      this.$refs.pop.doShow()
      window.setTimeout(() => {
        this.$refs.pop.popperElm.querySelector('textarea').focus()
      }, 1)
    },
    handleShowPop (event, col, lang) {
      if (this.$refs.pop.showPopper) {
        this.$refs.pop.handleBlur() 
        window.setTimeout(() => {
          this.showPop(event, col, lang)
        }, 300)
      } else {
        this.showPop(event, col, lang)
      }
    },
    handleSubmit () {
      if (!this.editText) return
      let item = this.editItem
      let lang = this.editLang
      let data = Object.assign({}, item.params, { 
        key: item.key,
        language: lang,
        translation: this.editText,
        original: item.translations[lang]
      })
      this.$http.post(this.updateUrl || this.$urls.locale_update, data, {
        params: {id: this.group}
      }).then(res => {
        if (lang === item.keyLanguage) {
          item.key = data.translation
        }
        this.$set(item.translations, lang, data.translation)
        this.$refs.pop.doClose()
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleEditChange () {
      if (this.editItem && this.editLang) {
        if (!('modifies' in this.editItem)) {
          this.editItem.modifies = {}
        }
        this.editItem.modifies[this.editLang] = this.editText
      }
    }
  }
}
</script>

<style lang="scss">
.langs-filters{
  min-width: 0 !important;
}
.locale-view{
  >.toolbar{
    display: flex;
    > .el-input, >.filter-item{
      max-width: 200px;
      margin-right:8px;
    }
  }
  .langs-column{
    cursor: pointer;
    &:hover{
      color:#409EFF;
    }
  }
  .trans{
    color: #606266 !important;
    text-decoration: none;
    &:hover{
      text-decoration: underline;
    }
    &.empty{
      color: #E6A23C !important;
    }
  }
}
</style>
